import React, { useContext } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import "./Settings.scss";

const Settings = () => {
  const { setThemeColor, themeColor } = useContext(ThemeContext);

  const themeColors = [
    "#004A9A",
    "#F8F9FA",
    "#F4F7FE",
    "#262626",
    "#C0C8D3",
    "#DA5C19",
    "#D9D9D9",
    "#964B00",
  ];

  return (
    <>
      <div className="themesel">
        <div className="setting-th">
          <div className="setting-first">
            <span className="themesel-title">Theme</span>
          </div>
          <div className="theme-colors setting-first-data">
            {themeColors.map((color, index) => (
              <div
                key={index}
                className={`themecol ${themeColor === color ? "selected" : ""}`}
                style={{ backgroundColor: color }}
                onClick={() => setThemeColor(color)}
              />
            ))}
          </div>
        </div>

        <div className="setting-th">
          <div className="setting-second">
            <span className="themesel-title">Staging</span>
          </div>
          <div className="setting-second-data">
            <select className="dashboard-staging-dropdown">
              <option>Option 1</option>
              <option>Option 2</option>
              <option>Option 3</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
